import React from 'react';
import { Container, Error, RefreshButton } from './styled';

type ErrorBoundaryFallbackUIProps = {
  width?: string;
  height?: string;
};

export const ErrorBoundaryFallbackUI = ({ width, height }: ErrorBoundaryFallbackUIProps) => {
  return (
    <Container width={width} height={height}>
      <Error>Uh-oh! Looks like something didn't go quite right. Please try again!</Error>
      <RefreshButton
        onClick={() => {
          window.location.replace('/');
          requestAnimationFrame(() => {
            window.location.href = '/';
          });
        }}
      >
        Refresh
      </RefreshButton>
    </Container>
  );
};
